import Main from "./main/main.es6";

const main = new Main();
